// ./src/utils/guestPhoto.ts
//
// A GUEST'S PHOTO (ROADMAP A2d #69) — who may set it, and which picture to show. Import-free on purpose, so
// `check-guest-photo` RUNS it.
//
// ⚠ WHO mirrors the server (API `boundary/guestPhoto.ts` → `canSetGuestPhoto`): the event's account (the host), or crew
//   signed in with an ACCOUNT whose role is host or co-host — never an organizer, never a password crew link. The guard
//   pins the two role lists equal; the server refuses anyone else ON the field whatever this says.

/** The crew roles that may set a guest's photo — when signed in with an account. */
export const GUEST_PHOTO_ROLES: readonly string[] = ['host', 'co_host'];

export const canSetGuestPhoto = (caller: { isOwner: boolean; viaPasswordCrew: boolean; role: string | null }): boolean =>
  caller.isOwner || (!caller.viaPasswordCrew && !!caller.role && GUEST_PHOTO_ROLES.includes(caller.role));

export interface GuestPhotoSource {
  /** The guest's own photo for this event (#69). */
  avatarUploadedFile?: { fileUrl?: string | null; thumbnailUrl?: string | null } | null;
  /** A user-backed crew member's live ms_auth avatar. */
  avatarUrl?: string | null;
  /** The linked contact — their uploaded photo, else the server's Gravatar. */
  person?: { avatarUploadedFile?: { fileUrl?: string | null } | null; avatarGravatarUrl?: string | null } | null;
}

/**
 * The picture to show for a guest: their own photo for this event, else a crew member's account picture, else the
 * contact's photo, else the contact's Gravatar — the public site's order (guest ?? contact) with the crew picture
 * between. Null → initials.
 */
export const guestPhotoUrl = (g: GuestPhotoSource | null | undefined): string | null =>
  g?.avatarUploadedFile?.fileUrl ||
  g?.avatarUploadedFile?.thumbnailUrl ||
  g?.avatarUrl ||
  g?.person?.avatarUploadedFile?.fileUrl ||
  g?.person?.avatarGravatarUrl ||
  null;
